import { render } from "./CandidatureOffre.vue?vue&type=template&id=56de693a&ts=true"
import script from "./CandidatureOffre.vue?vue&type=script&lang=ts"
export * from "./CandidatureOffre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__